import { addItemToCollection } from "directus/src/operations";

export async function createQuestion({ item }) {
  try {
    const data = await addItemToCollection("survey_questions", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
